import { css } from "@emotion/css";

export const fontFamily = css`
    font-family: var(--font-family) !important;
`;

export const fontFamilySecondary = css`
    font-family: var(--font-family-secondary) !important;
`;
